import Contador from "./Contador";

export default function Atv02() {
    return(
        <>
            <h1>Atividades da Semana 2</h1>
            <Contador />
        </>
    );
}